export default __webpack_public_path__ + "static/media/about-7.c2065560.png";